/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";


const SERVICE_NAME = 'enable-claim.service';
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class EnableClaimService {
    name=SERVICE_NAME;
    private static instance: EnableClaimService;

    private constructor() {
        this.report();
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = new EnableClaimService();
        }
        return this.instance;
    }

    async enableClaim(payload: any) {
        console.log(`payload in enable-claim.service :`, payload)
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            // if (client) {
            //     // const res = await client.mutate({
            //     //     query: ASSETS_TABLE,
            //     //     variables: {
            //     //         assetTableCriteria: {
            //     //             state: "listed"
            //     //         },
            //     //         assetTableOffset: 0,
            //     //         assetTableSize: 5000
            //     //     },
            //     //     fetchPolicy:'network-only'
            //     // });
            // }
            return true;
        } catch (err) {

        }
    }

    private report() {
        log?.info(SERVICE_NAME,`⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME,'Module Report');
        log?.info(SERVICE_NAME, '⦿ Name: ' + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}